export default {
  namespaced: true,
  state: () => ({
    menu: [],
  }),
  getters: {
  },
  mutations: {
    /**
     * 设置菜单
     * @param {*} list 
     */
    setMenu(state, list) {
      state.menu = list
    },
  },
  actions: {
  },
}
